import React from 'react';
import BlacksmithLandingPage from './BlacksmithLandingPage';

function App() {
  return <BlacksmithLandingPage />;
}

export default App;
